/* global yaCounterNUMBERID */
import helpers from '../helpers';
import scrollDepth from 'scroll-depth';

function init() {
	function start15SecTimeout() {
		clearTimeout(helpers.$window.data('timeout15Sec'));

		helpers.$window.data('timeout15Sec', setTimeout(() => {
			ga('send', 'event', 'page', 'spent_on_page_15_sec');
		}, 15000));
	}

	start15SecTimeout();

	scrollDepth({
		userTiming: false,
		pixelDepth: false,
		gtmOverride: true,
		eventHandler(data) {
			ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		},
	});

	/**
	* Создать куки запись
	* @param {string} path Обязательное, ссылка/путь
	*/
	// function virtualHit(path) {
	// 	if (window.ga) {
	// 		ga('set', 'page', path);
	// 		ga('send', 'pageview', path);
	// 		// Не всегда используются
	// 		// ga('rbcspec.set', 'page', path);
	// 		// ga('rbcspec.send', 'pageview', path);
	// 	}

	// 	// NUMBERID нужно менять для каждого проекта, так же используется в PUG
	// 	if (window.yaCounterNUMBERID) {
	// 		yaCounterNUMBERID.hit(path);
	// 	}
	// }

	document.addEventListener('click', (e) => {
		// partners slider
		if (e.target.closest('.partners-item') || e.target.classList.contains('prtners-item')) {
			const link = e.target.href ? e.target.href : e.target.closest('.partners-item').href;
			ga('send', 'event', 'partner links', 'bottom page', link);
		}

		// partners card
		if (e.target.closest('.card-partners') || e.target.classList.contains('card-partners')) {
			const element = e.target.closest('.card-partners') ? e.target.closest('.card-partners') : e.target;
			const text = element.querySelector('.card-partners__name').innerText;
			ga('send', 'event', 'partner links', 'site section', text);
		}

		// button-send-request
		if (e.target.id === 'button-send-request') {
			ga('send', 'event', 'award', 'click button send request');
		}

		// sharing
		if (e.target.closest('.social-item') || e.target.classList.contains('social-item')) {
			const element = e.target.closest('.social-item') ? e.target.closest('.social-item') : e.target;
			const socialName = element.getAttribute('data-social');
			ga('send', 'event', 'share', 'project share', socialName);
		}

		// footer telegram link
		if (e.target.id === 'telegram-link') {
			ga('send', 'event', 'telegram', 'go to telegram');
		}

		if (e.target.classList.contains('btn-social-auth')) {
			ga('send', 'event', 'public vote', 'open auth popup');
		}

		if (e.target.classList.contains('golosovaniye__vote-btn')) {
			const name = e.target.closest('.golosovaniye__item').querySelector('h3').innerText;
			ga('send', 'event', 'public vote', 'vote success', name);
		}
	});
}

if (!document.querySelector('.lichnyj-kabinet')) {
	init();
}
